export const setupSurchargeToggle = () => {
    const methodSelect = document.getElementById("Method");
    if (methodSelect) {
        methodSelect.addEventListener("change", function () {
            const showSurcharge = methodSelect.value !== "Bank Transfer";
            document.querySelector(".without-surcharge").style.display =
                showSurcharge ? "none" : "block";
            document.querySelector(".with-surcharge").style.display =
                showSurcharge ? "block" : "none";
        });
    }
};
